import { Component } from '@angular/core';

@Component({
  selector: 'app-job-detail-two',
  templateUrl: './job-detail-two.component.html',
  styleUrls: ['./job-detail-two.component.css']
})
export class JobDetailTwoComponent {
   // Set Topbar Option
   Menuoption = 'job';
  Settingicon = true
  footerVariant = 'bg-light';
}
